import React from 'react'

import {__isAvailable} from "../../../_helpers";
import styled from "@emotion/styled";
import sv from "../../../styles/styles";
import zoomIcon from "../../../images/zoom.svg";
import {withTranslation} from "react-i18next";
import {withRouter} from "react-router-dom";

// STYLE ##########################################################

export const ZoomPitchViewTypes = {
	LANDING : 'ZOOM_VIEW_LANDING',
	BOXED   : 'ZOOM_VIEW_BOXED',
};

const MAIN = ZoomPitchViewTypes.LANDING;

const MainPitch = styled(`div`)`
  ${props => props.view === MAIN ? sv.h1 : sv.h2};
  color: ${props => props.view === MAIN ? sv.colors.cta : ''};
  text-align: center;
  margin-bottom: ${props => props.view === MAIN ? '20px' : ''};
`;

const SubPitch = styled(`div`)`
  color: ${sv.colors.dark};
  text-align: center;
  line-height: 1.3em;
  margin-bottom: ${props => props.view === MAIN ? '16px' : ''};
`;

const ZoomIcon = styled('img')`
  width: ${props => props.view === MAIN ? '150px' : '200px'};
  margin: ${props => props.view === MAIN ? '' : '55px 0'};    
`;

const ZoomPitchButton = styled(`div`)`
  display: block;
  margin: inherit auto 15px;
  font-size: 15px;
  ${sv.buttonBase};
  background: rgba(255, 255, 255, .2);
  color: ${sv.colors.light};
  box-shadow: 0 2px 4px rgba(0, 0, 0, .05);
  &:hover {
    box-shadow: 0 3px 6px rgba(0, 0, 0, .1);
  }
`;

const PitchButton = styled(ZoomPitchButton)`
  color: ${sv.colors.light};
  min-width: 200px;
  background: linear-gradient(278.78deg, #F4AD46 13.2%, #C45E00 91.01%);
  box-shadow: 0 2px 4px rgba(0,0,0,.2);
  &:hover {
    box-shadow: 0 3px 6px rgba(0,0,0,.4);
  }
`;

// COMPONENT ##########################################################

const ZoomPitchContents =  ({t, isLoggedIn, isZoomAvailable, viewType, history}) => {

	const isZoomLandingPage =  __isAvailable(viewType) && viewType === MAIN;
	const getIcon = <ZoomIcon src={zoomIcon} alt="Zoom" view={viewType} />;
	const getMainPitch = <MainPitch view={viewType}>{t('Gistify your recordings!')}</MainPitch>;

	const getPitchButton = () => {
		let pitchButton;
		if(isZoomLandingPage) {
			pitchButton = (isLoggedIn)
				? (isZoomAvailable)
					? <PitchButton onClick={() => history.push('/order/zoom')}>{t(`Create Gist`)}</PitchButton>
					: <PitchButton onClick={() => history.push('/zoom/connect')}>{t('Start using Gistify for Zoom')}</PitchButton>
				: <PitchButton onClick={() => history.push('/signup')}>{t('Start Your Free Trial')}</PitchButton>
		} else {
			pitchButton = <PitchButton onClick={() => history.push('/zoom')}>{t('Learn More')}</PitchButton>
		}
		return pitchButton;
	}

	return (
		<>
			{/* in case of landing page - icon then pitch */}
			{ isZoomLandingPage &&
			<>
				{getIcon}
				{getMainPitch}
			</>
			}

			{/* in case of box view - pitch then icon */}
			{ !isZoomLandingPage &&
			<>
				{getMainPitch}
				{getIcon}
			</>
			}

			<SubPitch view={viewType}>
				{t('Easily leverage the Zoom service to extract relevance and meaning from your online meetings. No longer is it necessary to spend so much energy trying to find that key moment.')}
			</SubPitch>

			{getPitchButton()}
		</>
	);
};

const connectedPitchContents = withTranslation()(withRouter(ZoomPitchContents));
export { connectedPitchContents as ZoomPitchContents };
